import { Link } from '@tanstack/react-router';

import { MessageSquareWarning } from './icons';
import { PageContainer } from './layout/page-container';
import { EmptyState } from './ui/empty-state';
import { PILL_TAB, PILL_TAB_ON } from './ui/pill-tab';
import { cn } from '../lib/utils';

/**
 * 라우트 loader 가 실패했을 때(API 장애) — 레이아웃 안의 오류 화면. 서버 응답은 500 이다
 * (docs/SSR.md 「실패 시 동작」). 없는 글은 여기가 아니라 루트의 notFoundComponent(404) 로 간다.
 */
export function RouteError() {
  return (
    <PageContainer>
      <EmptyState
        icon={<MessageSquareWarning />}
        title="불러오지 못했다."
        description="잠시 뒤에 다시 열어 보자."
        action={<Link to="/news" className={cn(PILL_TAB, PILL_TAB_ON)}>지원사업으로</Link>}
      />
    </PageContainer>
  );
}
